import React from 'react';
import { SUPPORT_EMAIL } from '../data/content';
const links = [{
  label: 'Términos y Condiciones',
  href: '#terminos'
}, {
  label: 'Política de Privacidad',
  href: '#privacidad'
}, {
  label: 'Contacto',
  href: `mailto:${SUPPORT_EMAIL}`
}];
export function Footer() {
  return <footer className="bg-marron" data-id="element-68" data-mp="36p6cmy1f4wbo">
      <div className="mx-auto max-w-2xl px-4 py-5 pb-20 text-center sm:pb-5" data-id="element-69" data-mp="36qhdaozkhnyk">
        <p className="text-xs text-crudo/85" data-id="element-70" data-mp="3ueih5klswg7n">© 2026 — Todos los Derechos Reservados.</p>
        <p className="mt-1.5 text-[0.68rem] leading-snug text-crudo/70" data-id="element-71" data-mp="38h7nghhhuo4">
          Mega Pack Macramé Desde Cero™ es un producto educativo digital. Los
          resultados obtenidos dependen de la práctica, dedicación, materiales
          utilizados y experiencia de cada persona. El contenido relacionado con
          emprendimiento, precios y comercialización tiene fines educativos y no
          garantiza ventas, clientes ni resultados económicos.
        </p>
        <p className="mt-1.5 text-xs text-crudo/85" data-id="element-72" data-mp="2ew70snw89o7j">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-arena underline-offset-2 transition-colors duration-150 ease-soft hover:text-crudo hover:underline" data-id="element-73" data-mp="3la28msb12zu6">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1.5" data-id="element-74" data-mp="3q8dk17gz1iei">
          <ul className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-xs text-crudo/85" data-id="element-75" data-mp="3qazp90ge3ltk">
            {links.map((link, i) => <li key={link.label} className="flex items-center gap-2" data-id="element-76" data-mp="32w3duq73ebb" data-mpi={i}>
                {i > 0 && <span aria-hidden="true" data-id="element-77" data-mp="htd4fcyx427o">•</span>}
                <a href={link.href} className="whitespace-nowrap transition-colors duration-150 ease-soft hover:text-arena" data-id="element-78" data-mp="huwiqy10k36t">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
      </div>
    </footer>;
}